import { CreateService } from '@/services/service';
import { MissionExecutionCountEntity } from '@/entities/mission-execution-count.entity';
import moment from 'moment';

export default class MissionExecutionCountService extends CreateService<MissionExecutionCountEntity>(
  'mission-execution-count',
) {
  async getManyByMonthAndYear(): Promise<Array<MissionExecutionCountEntity>> {
    this.apiBuilder.reset()
    const [rows] = await this.apiBuilder
      .filter('month', '$eq', `${moment().month() + 1}`)
      .filter('year', '$eq', `${moment().year()}`)
      .getMany();
    return rows;
  }
}

export function useMissionExecutionCountService() {
  return new MissionExecutionCountService();
}
